import React from 'react';

export default function Home() {
    return (
        <div class="content">
            <h1 class="title">About Cow Media</h1>
            <div class="about">
                The one-stop-shop for all things cows! Enjoy cow-posting with
                your friends. Examples of riveting cow topics to be found
                include discussions on the drag coefficient of a cow, the
                airspeed velocity of an unladen cow, and more! Jump right in
                and add to the conversation with your own exciting cow-ventures!
            </div>
        </div>
    );
}